//Services payload formation for create and update job
export const servicesArray = (data, getWarningInfo = false) => {
  let serviceDetails = data;
  let services = [];
  let transferArray = serviceDetails?.filter((item) => item.serviceType === "Transfer");
  let removalArray = serviceDetails?.filter((item) => item.serviceType === "Removal");
  let servicesDetailsTransfer = [];
  let servicesDetailsRemoval = [];
  if (transferArray.length !== 0) {
    for (let item of transferArray) {
      servicesDetailsTransfer.push(serviceDetailsObject(item, "transfer", getWarningInfo));
    }
  }
  if (removalArray.length !== 0) {
    for (let item of removalArray) {
      servicesDetailsRemoval.push(serviceDetailsObject(item, "removal", getWarningInfo));
    }
  }
  if (servicesDetailsTransfer.length !== 0) {
    services.push({
      type: "transfer",
      servicesDetails: servicesDetailsTransfer ?? [],
    });
  }
  if (servicesDetailsRemoval.length !== 0) {
    services.push({
      type: "removal",
      servicesDetails: servicesDetailsRemoval ?? [],
    });
  }
  return services;
};

function getVin(selectedVinOrPA) {
  if (!selectedVinOrPA?.isVin) {
    return null;
  }
  if (selectedVinOrPA.vin) {
    return selectedVinOrPA.vin;
  }
  return selectedVinOrPA.newVin;
}

//Each object of services payload
export const serviceDetailsObject = (item, type, getWarningInfo = false) => {
  let warningInfo = getWarningInfo
    ? {
        isWarning: item?.isWarning || false,
        warningReason: item?.warningReason,
      }
    : {};
  return {
    isDeleted: false,
    existingVehicle: {
      id: item?.existingVehicleId ?? null, // db generate when create
      vin: getVin(item?.selectedVinOrPA),
      year: null,
      make: null,
      model: null,
      vehicleName: item?.selectedVinOrPA?.isVin ? item?.selectedVinOrPA?.vehicleName : item?.selectedVinOrPA?.assetName,
      registrationNumber: item?.selectedVinOrPA?.isVin ? item?.selectedVinOrPA?.registrationNumber : item?.selectedVinOrPA?.assetNumber,
      revealCoreESN: item?.selectedVinOrPA?.esn || "NA", // VTU BOX core product
      isVin: item?.selectedVinOrPA?.isVin || false,
      cameras: item?.selectedVinOrPA?.cameras || [],
    },
    newVehicle:
      type === "transfer"
        ? {
            id: item?.newVehicleId ?? null, // db generate when create
            vin: item?.selectedVinOrPA?.isVin ? item?.vin : null,
            year: null,
            make: null,
            model: null,
            vehicleName: item?.newVehicle,
            registrationNumber: null,
            revealCoreESN: null, // VTU BOX core product
          }
        : null,
    relatedServices: item?.selectedVinOrPA?.isVin ? `${item?.selectedCameraAndAccessories?.join(",")}` : "NA",
    uiIndex: item?.uiIndex,
    ...warningInfo,
  };
};

//Address payload for create and update job
// export const addressPayload = (userSelectedAddressOption, addressFormValues) => {
//   return {
//     address1:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.formAddress?.address1 ?? ""
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.address1 ?? ""
//         : null,
//     address2:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.formAddress?.address2 ?? ""
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.address2 ?? ""
//         : null,
//     city:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.formAddress?.city ?? ""
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.city ?? ""
//         : null,
//     stateCode:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.formAddress?.state ?? ""
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.stateCode ?? ""
//         : null,
//     country: "United States",
//     countryCode:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.standardizedInfo?.standardizedAddress?.iso3CountryCode ?? ""
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.countryCode ?? ""
//         : null,
//     suggestedAddress:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.standardizedInfo?.standardizedAddress?.formattedAddress ?? ""
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.suggestedAddress ?? ""
//         : null,
//     zipCode:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.formAddress?.zip ?? ""
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.zipCode ?? ""
//         : null,
//     timezone:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.newAddressLocation?.timezone ?? ""
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.timeZone ?? ""
//         : null,
//     locusLocationId:
//       userSelectedAddressOption === "add-new-address"
//         ? Number(addressFormValues?.newAddress?.newAddressLocation?.locationId) ?? ""
//         : userSelectedAddressOption === "use-existing-address"
//         ? Number(addressFormValues?.existingAddress?.locusLocationId) ?? ""
//         : null,
//     addressByPass: userSelectedAddressOption === "add-new-address" ? addressFormValues?.newAddress?.addressByPass ?? "" : null,
//     locationFound:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.isLocationFound ?? false
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.isLocationFound ?? false
//         : null,
//     latitude:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.standardizedInfo?.standardizedAddress?.latLong?.latitude ?? null
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.latitude ?? null
//         : null,
//     longitude:
//       userSelectedAddressOption === "add-new-address"
//         ? addressFormValues?.newAddress?.standardizedInfo?.standardizedAddress?.latLong?.longitude ?? null
//         : userSelectedAddressOption === "use-existing-address"
//         ? addressFormValues?.existingAddress?.longitude ?? null
//         : null,
//   };
// };

// Helper to compare newAddress.formAddress and newAddress.inputAddress with correct key mapping
const areAddressesEqual = (formAddress, inputAddress) => {
  if (!formAddress || !inputAddress) return false;

  // For ZIP comparison - both formAddress.zip and inputAddress.postalCode are 5 digits only
  const formZip = formAddress.zip || "";
  const inputZip = inputAddress.postalCode || "";

  return (
    formAddress.address1 === inputAddress.addressLine1 &&
    formAddress.address2 === inputAddress.addressLine2 &&
    formAddress.city === inputAddress.city &&
    formAddress.state === inputAddress.stateProvince &&
    formZip === inputZip &&
    formAddress.country === inputAddress.country
  );
};

// Helper to get zipCode value based on address state - only 5 digits
function getZipCode({ isNewAddress, isFormAndInputAddressEqual, formAddress, standardizedAddress, existingAddress }) {
  if (isNewAddress && isFormAndInputAddressEqual) {
    return formAddress?.zip ?? "";
  }
  if (isNewAddress && !isFormAndInputAddressEqual) {
    return standardizedAddress?.postalCodeBase ?? "";
  }
  // Ensure existing address ZIP is also 5 digits only
  const existingZip = existingAddress?.zipCode ?? "";
  return existingZip ? existingZip.substring(0, 5) : "";
}
export const addressPayload = (userSelectedAddressOption, addressFormValues) => {
  const isNewAddress = userSelectedAddressOption === "add-new-address";
  const isExistingAddress = userSelectedAddressOption === "use-existing-address";

  const newAddress = addressFormValues?.newAddress;
  const existingAddress = addressFormValues?.existingAddress;

  let formAddress = null;
  let location = null;
  if (isNewAddress) {
    formAddress = newAddress?.formAddress;
    location = newAddress?.newAddressLocation;
  } else if (isExistingAddress) {
    formAddress = existingAddress;
    location = existingAddress;
  }
  const standardizedAddress = isNewAddress ? newAddress?.standardizedInfo?.standardizedAddress : null;

  const isFormAndInputAddressEqual = areAddressesEqual(newAddress?.formAddress, newAddress?.inputAddress);
  function getStateCode(isNewAddress, isExistingAddress, addressFormValues) {
    if (isNewAddress) {
      return addressFormValues?.newAddress?.formAddress?.state ?? "";
    }
    if (isExistingAddress) {
      return addressFormValues?.existingAddress?.stateCode ?? "";
    }
    return null;
  }

  function getCountry(isNewAddress, isExistingAddress, addressFormValues) {
    if (isNewAddress) {
      return "USA";
    }
    if (isExistingAddress) {
      return addressFormValues?.existingAddress?.country ?? "USA";
    }
    return "USA";
  }

  console.log("addressPayload called with:", { userSelectedAddressOption, addressFormValues });

  return {
    address1: formAddress?.address1 ?? "",
    address2: formAddress?.address2 ?? "",
    city: formAddress?.city ?? "",
    stateCode: getStateCode(isNewAddress, isExistingAddress, addressFormValues),
    // country: "United States", // Replace with a constant if needed
    country: getCountry(isNewAddress, isExistingAddress, addressFormValues),
    countryCode: standardizedAddress?.iso3CountryCode ?? existingAddress?.countryCode ?? "",
    suggestedAddress: standardizedAddress?.formattedAddress ?? existingAddress?.suggestedAddress ?? "",
    zipCode: getZipCode({ isNewAddress, isFormAndInputAddressEqual, formAddress, standardizedAddress, existingAddress }),
    timezone: location?.timezone ?? "",
    locusLocationId: Number(location?.locationId ?? existingAddress?.locationLocationId) || null,
    addressByPass: isNewAddress ? newAddress?.addressByPass ?? "" : null,
    locationFound: location?.isLocationFound ?? false,
    latitude: standardizedAddress?.latLong?.latitude ?? existingAddress?.latitude ?? null,
    longitude: standardizedAddress?.latLong?.longitude ?? existingAddress?.longitude ?? null,
  };
};

//contact payload for create and update job
export const contactPayload = (userSelectedContactOption, contactFormValues) => {
  return {
    contactName:
      userSelectedContactOption === "use-existing-contact"
        ? `${contactFormValues?.existingContact?.firstName ?? ""} ${contactFormValues?.existingContact?.lastName ?? ""}`
        : `${contactFormValues?.newContact?.firstName ?? ""} ${contactFormValues?.newContact?.lastName ?? ""}`,
    phone:
      userSelectedContactOption === "use-existing-contact"
        ? contactFormValues?.existingContact?.mobileNumber ?? ""
        : contactFormValues?.newContact?.mobileNumber ?? "",
    email:
      userSelectedContactOption === "use-existing-contact"
        ? contactFormValues?.existingContact?.email ?? ""
        : contactFormValues?.newContact?.email ?? "",
  };
};

function getCreatedBy(contactFormValues, firstName, surname) {
  const existing = contactFormValues?.existingContact;
  if (existing?.firstName && existing?.lastName) {
    return `${existing.firstName} ${existing.lastName}`;
  }
  return `${firstName ?? ""} ${surname ?? ""}`;
}

//jobDetails payload for update and create job
export const jobDetailsPayload = (
  transferArray,
  removalArray,
  caseSfdcId,
  caseNumber,
  { firstName, surname } = {},
  jobResponse,
  contactFormValues
) => [
  {
    id: Number(jobResponse?.id),
    primaryDevice: jobResponse?.primaryDevice ?? null,
    addOns: "updated",
    vehicleCount: (transferArray?.length ?? 0) + (removalArray?.length ?? 0),
    jobType: "Support/De-Re",
    opportunityId: jobResponse?.opportunityId ?? null,
    cspOwner: "",
    cspName: "",
    cspSfdcId: "",
    caseSfdcId: caseSfdcId ?? "",
    caseOwner: "Customer Portal Integration User",
    caseNumber: caseNumber ?? "",
    modifiedAt: new Date().toISOString(),
    modifiedBy: jobResponse?.id ? `${firstName ?? ""} ${surname ?? ""}` : "",
    createdAt: jobResponse?.id ? jobResponse?.createdAt : new Date().toISOString(),
    createdBy: jobResponse?.id ? jobResponse?.createdBy : getCreatedBy(contactFormValues, firstName, surname),
    isDeleted: false,
    workTickets: [
      {
        workTicket: "",
      },
    ],
  },
];

//In update job api if address is updated, addressId should be sent as null
export const checkIfAddressIsUpdated = (userSelectedAddressOption, createJobRes, addressFormValues) => {
  const fieldsToCompare = ["address1", "address2", "city", "stateCode", "zipCode"];
  let isUpdated = false;
  fieldsToCompare.forEach((field) => {
    if (userSelectedAddressOption == "add-new-address") {
      const compareWithField = fieldMaping(field);
      const isNewUpdated =
        addressFormValues?.newAddress?.formAddress[compareWithField] &&
        createJobRes[field] !== addressFormValues?.newAddress?.formAddress[compareWithField];
      if (isNewUpdated) {
        isUpdated = true;
      }
    } else if (userSelectedAddressOption == "use-existing-address") {
      const isExistingUpdated = addressFormValues?.existingAddress[field] && createJobRes[field] !== addressFormValues?.existingAddress[field];
      if (isExistingUpdated) isUpdated = true;
    }
  });
  return isUpdated;
};

const fieldMaping = (val) => {
  if (val == "stateCode") return "state";
  if (val == "zipCode") return "zip";
  return val;
};

export function caseSubjectField(transferCount, removalCount) {
  const subject = [];
  if (transferCount > 0) {
    const transferText = transferCount > 1 ? "transfers" : "transfer";
    subject.push(`${transferCount} ${transferText}`);
  }
  if (removalCount > 0) {
    const removalText = removalCount > 1 ? "removals" : "removal";
    subject.push(`${removalCount} ${removalText}`);
  }
  return subject.join(", ");
}

export const flattenServiceDetaisArray = (serviceDetails) => {
  let services = transformArray(serviceDetails);
  return services?.flatMap((service) => {
    return service.servicesDetails.map((details) => ({
      vehicleName: details?.existingVehicle?.vehicleName,
      registrationNumber: details?.existingVehicle?.registrationNumber,
      revealCoreESN: details?.existingVehicle?.revealCoreESN,
      serviceType: service.type,
      vin: details?.existingVehicle?.vin,
      newVehicle: { ...details?.newVehicle },
      accessories: details.relatedServices,
    }));
  });
};

function transformArray(inputArray) {
  const result = [];
  inputArray.forEach((item) => {
    // Find if the type already exists in the result array
    let existingType = result.find((res) => res.type === item.serviceType.toLowerCase());
    const { isDeleted, existingVehicle, newVehicle, relatedServices, uiIndex } = item;
    // Create the transformed serviceDetails object
    const serviceDetails = {
      isDeleted: isDeleted,
      existingVehicle: existingVehicle,
      newVehicle: newVehicle,
      relatedServices: relatedServices,
      uiIndex: uiIndex,
    };
    // If the type already exists, push the serviceDetails into its servicesDetails array
    if (existingType) {
      existingType.servicesDetails.push(serviceDetails);
    } else {
      // Otherwise, create a new type entry
      result.push({
        type: item.serviceType.toLowerCase(),
        servicesDetails: [serviceDetails],
      });
    }
  });

  return result;
}
